import CheckIcon from '@mui/icons-material/Check';

export interface StepItem {
  key: string;
  label: string;
}

interface Props {
  steps: StepItem[];
  currentIndex: number;
}

export function ConnectStepRail({ steps, currentIndex }: Props) {
  return (
    <ol className="connect-rail" aria-label="Connect progress">
      {steps.map((s, i) => {
        const done = i < currentIndex;
        const active = i === currentIndex;
        const state = done ? 'done' : active ? 'active' : 'upcoming';
        return (
          <li
            key={s.key}
            className={`connect-rail__step is-${state}`}
            {...(active ? { 'aria-current': 'step' as const } : {})}
          >
            <span className="connect-rail__marker">
              {done ? <CheckIcon sx={{ fontSize: 14 }} /> : <span>{i + 1}</span>}
            </span>
            <span className="connect-rail__label">{s.label}</span>
          </li>
        );
      })}
    </ol>
  );
}
